// @flow

import HeadSetter from './head-setter.jsx';


export default HeadSetter;
